import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionsBeforeInvestingPanel"},[(_vm.isActive)?_c('div',[(_vm.questions.length > 0)?_c('div',{staticClass:"questionCards"},_vm._l((_vm.questions),function(q,index){return _c('QuestionCard',{key:index,attrs:{"question":q}})}),1):_c('div',[_c(VSkeletonLoader,{attrs:{"type":"list-item-three-line"}})],1)]):_c('div',[_c('LockedControl',{attrs:{"minPlan":_vm.minPlan}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }